// extracted by mini-css-extract-plugin
export default {"Table":"table_Table__9AAwa","Row":"table_Row__eCX5m","Header":"table_Header__N+fZL","Body":"table_Body__8iLav","Cell":"table_Cell__kAIpr","Message":"table_Message__tHQGg"};